/**
 * adjacentDates — given the ASC-sorted available dates for the active product
 * and the currently selected date, return the immediate previous and next
 * dates (or null at the ends).
 *
 * AK-193 (ADR-037 #6, audit F1): date-stepping cold-fetches each date's tiles,
 * so every click on a neighbouring day blanks then pops. Warming the prev/next
 * tiles before the user steps removes the gap. This helper isolates the
 * neighbour computation so it is unit-testable without a map or store.
 *
 * `dates` is expected ASC (ISO date strings sort lexicographically =
 * chronological), matching what SatelliteStrip / useDatesEffect already
 * produce. We defensively sort a copy so an unsorted caller can't break the
 * neighbour math.
 */
export function adjacentDates(
  dates: readonly string[],
  selected: string | null,
): { prev: string | null; next: string | null } {
  if (!selected || dates.length === 0) return { prev: null, next: null };
  const sorted = [...dates].sort();
  const i = sorted.indexOf(selected);
  if (i === -1) return { prev: null, next: null };
  return {
    prev: i > 0 ? sorted[i - 1] : null,
    next: i < sorted.length - 1 ? sorted[i + 1] : null,
  };
}
